import React, { useState } from 'react';
import {
  FeedbackButtons as FeedbackButtons__Root,
  FeedbackButtons__Btn,
} from './FeedbackButtons.styles';

interface FeedbackButtonsProps {
  messageId: string;
  traceId: string;
  onFeedback: (messageId: string, traceId: string, isPositive: boolean, resetSelection: () => void) => void;
}

export const FeedbackButtons: React.FC<FeedbackButtonsProps> = ({
  messageId,
  traceId,
  onFeedback,
}) => {
  const [selected, setSelected] = useState<'up' | 'down' | null>(null);

  const resetSelection = () => {
    setSelected(null);
  };

  const handleThumbsUp = () => {
    setSelected('up');
    onFeedback(messageId, traceId, true, resetSelection);
  };

  const handleThumbsDown = () => {
    setSelected('down');
    onFeedback(messageId, traceId, false, resetSelection);
  };

  return (
    <FeedbackButtons__Root>
      <FeedbackButtons__Btn
        $selected={selected === 'up'}
        $isPositive={true}
        onClick={handleThumbsUp}
        disabled={selected !== null}
        aria-label="Good response"
        title="Good response"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill={selected === 'up' ? 'currentColor' : 'none'}
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" />
        </svg>
      </FeedbackButtons__Btn>

      <FeedbackButtons__Btn
        $selected={selected === 'down'}
        $isPositive={false}
        onClick={handleThumbsDown}
        disabled={selected !== null}
        aria-label="Bad response"
        title="Bad response"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill={selected === 'down' ? 'currentColor' : 'none'}
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17" />
        </svg>
      </FeedbackButtons__Btn>
    </FeedbackButtons__Root>
  );
};
